module.exports = __webpack_public_path__ + "img/2021-3.ca666160.jpg";